import { useWalletBicCountry } from '@/features/wallets/hooks/useWalletBicCountry';

import { Flag } from '@/ui-kit/flag/Flag';

export interface IWalletBicProps {
  bic: string;
}

export function WalletBic({ bic }: IWalletBicProps) {
  const country = useWalletBicCountry(bic);

  return (
    <div className="flex gap-2">
      <Flag country={country} />
      <span className="typo-body-regular-caption">{bic}</span>
    </div>
  );
}
